import React, { Dispatch, SetStateAction, useState, useEffect } from "react";
import {
  TextField,
  InputAdornment,
  MenuItem,
  Select,
  FormControl,
  Grid,
  Box,
  SelectChangeEvent,
} from "@mui/material";
import Flag from "react-world-flags"; // For displaying country flags
import {
  CountryCode,
  isValidPhoneNumber,
  parsePhoneNumberFromString,
} from "libphonenumber-js"; // Import validation functions
import { countryCodeList } from "../../constants/constants";
import { useRegion } from "../../context/RegionContext";
import { REGIONS } from "../../constants/regions";

interface Props {
  setMainPhoneNumber: any;
  setMainCountryCode: any;
  errorMessage: string;
  setErrorMessage: Dispatch<SetStateAction<string>>;
}

const PhoneNumberInput = ({
  setMainCountryCode,
  setMainPhoneNumber,
  errorMessage,
  setErrorMessage,
}: Props) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const { region } = useRegion();
  const [countryCode, setCountryCode] = useState<CountryCode>(
    region === REGIONS.AE ? "AE" : "SA"
  );

  // Update country code when region changes
  useEffect(() => {
    const newCountryCode: CountryCode = region === REGIONS.AE ? "AE" : "SA";
    setCountryCode(newCountryCode);

    // Update the main country code as well
    const selectedCountry = countryCodeList.find(
      (country) => country.code === newCountryCode
    );
    if (selectedCountry) {
      setMainCountryCode(selectedCountry.label);
    }
  }, [region, setMainCountryCode]);

  const handleCountryChange = (event: SelectChangeEvent) => {
    setCountryCode(event.target.value as CountryCode);

    const selectedCountry = countryCodeList.find(
      (country) => country.code === event.target.value
    );

    if (selectedCountry) {
      setMainCountryCode(selectedCountry?.label);
    }
  };

  const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setPhoneNumber(value);
    setMainPhoneNumber(value);

    // Validate phone number when it's changed
    validatePhoneNumber(value);
  };

  const validatePhoneNumber = (number: string) => {
    const phoneNumber = parsePhoneNumberFromString(number, countryCode);

    if (phoneNumber && isValidPhoneNumber(number, countryCode)) {
      setErrorMessage(""); // Clear error if valid
    } else {
      setErrorMessage("Please add a valid phone number");
    }
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            fullWidth
            type="number"
            placeholder="Mobile Number"
            error={!!errorMessage}
            helperText={errorMessage}
            value={phoneNumber}
            onChange={handlePhoneChange}
            className="phone_input_field"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FormControl variant="outlined" size="small">
                    <Select
                      className="phone_input_select"
                      value={countryCode}
                      onChange={handleCountryChange}
                      displayEmpty
                      // IconComponent={() => <ArrowDropDown />}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 300,
                          },
                        },
                      }}
                    >
                      {countryCodeList.map((country) => (
                        <MenuItem key={country.code} value={country.code}>
                          <Box display="flex" alignItems="center">
                            <Flag
                              code={country.flag}
                              style={{ width: 20, height: 15, marginRight: 8 }}
                            />
                            {/* {country.code === countryCode
                              ? country.label
                              : country.code} */}
                            {country.code}
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default PhoneNumberInput;
